import type { ICore } from "@kunduz/data-access-core-api";

export function identifyStudent(student: ICore.IStudentV4): void {
  if (typeof window !== "undefined") {
    window.analytics.identify(student.user_id, {
      first_name: student.first_name,
      last_name: student.last_name,
      country_code: student.country?.code,
      phone: student.phone_number?.number,
      email: student.email,
      grade: student.grade,
      // is_parent: student.is_parent,
    });
  }
}
